import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolePipe } from './role.pipe';
import { PrinterTypePipe } from './printer-type.pipe'
import { KeysPipe } from './keys.pipe'


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RolePipe, PrinterTypePipe, KeysPipe],
  exports:[RolePipe,PrinterTypePipe,KeysPipe]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts